import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import SEOHead from "./components/SEOHead";
import Header from "./components/Header";
import Hero from "./components/Hero";
import ClientsSection from "./components/ClientsSection";
import ModulesSection from "./components/ModulesSection";
import IndustriesSection from "./components/IndustriesSection";
import TestimonialsSection from "./components/TestimonialsSection";
import FAQSection from "./components/FAQSection";
import CTASection from "./components/CTASection";
import Footer from "./components/Footer";
import FeaturesPage from "./pages/FeaturesPage";
import SurveyHubPage from "./pages/SurveyHubPage";
import MeetingRoomPage from "./pages/MeetingRoomPage";
import InvoicingPage from "./pages/InvoicingPage";
import AccessControlPage from "./pages/AccessControlPage";
import CRMPage from "./pages/CRMPage";
import CoworksPage from "./pages/CoworksPage";
import RealEstatePage from "./pages/RealEstatePage";
import MultifamilyPage from "./pages/MultifamilyPage";
import BusinessPage from "./pages/BusinessPage";
import MobileAppPage from "./pages/MobileAppPage";
import SalesPage from "./pages/SalesPage";
import InventoryPage from "./pages/InventoryPage";
import AccountingPage from "./pages/AccountingPage";
import HRPage from "./pages/HRPage";
import ProjectsPage from "./pages/ProjectsPage";
import HelpdeskPage from "./pages/HelpdeskPage";
import AttendancePage from "./pages/AttendancePage";
import SpacesHubPage from "./pages/SpacesHubPage";
import LogisticsPage from "./pages/LogisticsPage";
import EndpointPage from "./pages/EndpointPage";
import SkoPage from "./pages/SkoPage";
import DemoPage from "./pages/DemoPage";
import SupportPage from "./pages/SupportPage";
import AboutPage from "./pages/AboutPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import MaintenancePage from "./pages/MaintenancePage";

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <SEOHead />
      <Header />
      <Hero />
      <ClientsSection />
      <ModulesSection />
      <IndustriesSection />
      <TestimonialsSection />
      <FAQSection />
      <CTASection />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/features" element={<FeaturesPage />} />
            <Route path="/crm" element={<CRMPage />} />
            <Route path="/surveyhub" element={<SurveyHubPage />} />
            <Route path="/meetingroom" element={<MeetingRoomPage />} />
            <Route path="/facturacion" element={<InvoicingPage />} />
            <Route path="/control-acceso" element={<AccessControlPage />} />
            <Route path="/coworks" element={<CoworksPage />} />
            <Route path="/inmobiliarias" element={<RealEstatePage />} />
            <Route path="/multifamily" element={<MultifamilyPage />} />
            <Route path="/empresas" element={<BusinessPage />} />
            <Route path="/app-personalizada" element={<MobileAppPage />} />
            <Route path="/ventas" element={<SalesPage />} />
            <Route path="/inventario" element={<InventoryPage />} />
            <Route path="/contabilidad" element={<AccountingPage />} />
            <Route path="/rrhh" element={<HRPage />} />
            <Route path="/proyectos" element={<ProjectsPage />} />
            <Route path="/helpdesk" element={<HelpdeskPage />} />
            <Route path="/control-asistencia" element={<AttendancePage />} />
            <Route path="/spaceshub" element={<SpacesHubPage />} />
            <Route path="/logistica" element={<LogisticsPage />} />
            <Route path="/cloudbase-endpoint" element={<EndpointPage />} />
            <Route path="/sko" element={<SkoPage />} />
            <Route path="/demo" element={<DemoPage />} />
            <Route path="/soporte" element={<SupportPage />} />
            <Route path="/nosotros" element={<AboutPage />} />
            <Route path="/privacidad" element={<PrivacyPolicyPage />} />
            <Route path="/mantencion" element={<MaintenancePage />} />
            <Route path="/mantenimiento" element={<MaintenancePage />} />
          </Routes>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
